import { render, staticRenderFns } from "./udatalists4.vue?vue&type=template&id=6ad3447c&scoped=true&"
import script from "./udatalists4.vue?vue&type=script&lang=js&"
export * from "./udatalists4.vue?vue&type=script&lang=js&"
import style0 from "./udatalists4.vue?vue&type=style&index=0&id=6ad3447c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3447c",
  null
  
)

export default component.exports